import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './select.module.scss';

const Select = ({ children, label, disabled, error, defaultValue, ...rest }) => {
  const [value, setValue] = useState(defaultValue);

  return (
    <div className={styles.select}>
      {label ? (
        <div className={styles.label}>
          <label>{label}</label>
        </div>
      ) : null}
      <div
        className={classnames(styles.target, {
          [styles.disabled]: disabled,
          [styles.targetError]: error,
        })}
      >
        {defaultValue !== undefined ? (
          <select
            disabled={disabled}
            {...rest}
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              rest.onChange(e);
            }}
          >
            {children}
          </select>
        ) : (
          <select disabled={disabled} {...rest}>{children}</select>
        )}
      </div>
      {error ? (
        <div className={styles.error}>{error}</div>
      ) : null}
    </div>
  );
};

export default Select;
